// @flow

export { validator as paraguayanValidator } from './validator';
